import { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { CREATE_LEAD_URL } from "../../global/API";
import { InputMask } from "primereact/inputmask";

const EditLead = ({ selectedLeadId, leadsList, fetchData, paginationObj, setSelectedLeads }) => {
  const [leadDetails, setLeadDetials] = useState(null);

  const onHandleEvent = (event) => {
    const { name, value } = event.target;
    setLeadDetials((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    const { id, name, email, phone, message, tour_date } = leadDetails;
    const formValues = {
      name,
      email,
      phone,
      message,
      tour_date,
    };

    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      console.log(key, value);
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    try {
      const options = {
        method: "POST",
        body: formData,
      };
      const response = await fetch(CREATE_LEAD_URL + id, options);
      const data = await response.json();
      if (data.status === "Success") {
        setSelectedLeads([]);
        fetchData(paginationObj.current, paginationObj.pageSize);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const leadDetails = leadsList.data.filter((lead) => lead.id === selectedLeadId[0])[0];
    setLeadDetials(leadDetails);
  }, [selectedLeadId]);

  const renderFormView = () => {
    const { name, email, phone, message, tour_date, tour_time, type } = leadDetails;

    return (
      <div className="modal-body">
        <form onSubmit={onHandleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input type="name" name="name" onChange={onHandleEvent} className="form-control" value={name} />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input type="email" name="email" onChange={onHandleEvent} className="form-control" value={email} />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <InputMask mask="(999) 999 9999" name="phone" value={phone} onChange={onHandleEvent} placeholder="(123) 456-7890" className="form-control" />
          </div>

          {type === 3 && (
            <div className="mb-3">
              <label className="form-label">Tour Date</label>
              <div>
                <Calendar
                  id="newLeadCalendar"
                  name="tourdate"
                  value={new Date(tour_date)}
                  onChange={(e) =>
                    setLeadDetials((previousState) => ({
                      ...previousState,
                      tour_date: e.value,
                    }))
                  }
                  dateFormat="dd/mm/yy"
                  showTime
                  hourFormat="12"
                />
              </div>
            </div>
          )}
          <div className="mb-3">
            <label className="form-label">Message</label>
            <textarea name="message" className="form-control" rows="6" value={message} onChange={onHandleEvent}></textarea>
          </div>
          <div className="page-title-box">
            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">
              Submit
            </button>
            {/* <button type="submit" className="btn btn-secondary">
                  Cancel
                </button> */}
          </div>
        </form>
      </div>
    );
  };

  const [expandModal, setExpandModal] = useState("defaultScreen");

  useEffect(() => {
    const popupSidebar = document.querySelector(".modal-backdrop");

    if (popupSidebar && expandModal === "defaultScreen") {
      popupSidebar.classList.remove("remove-overlay");
    } else if (popupSidebar) {
      popupSidebar.classList.add("remove-overlay");
    }
  }, [expandModal]);

  return (
    <>
      <div className="modal fade filter-model leadPopup" id="editLead" aria-labelledby="editLeadLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="editLeadLabel">
                Edit Lead
              </h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ri-close-line"></i>
              </button>
            </div>
            {leadDetails && renderFormView()}
          </div>
        </div>
      </div>
    </>
  );
};
export default EditLead;
